import type { HubLookup } from '../types/hub-lookup.type';
import { GuidNameCodeModel } from './guid-name-code.model';
import { LocalDivisionLookupModel } from './local-division-lookup.model';

export class HubLookupModel extends GuidNameCodeModel implements HubLookup {
  readonly localDivisions: LocalDivisionLookupModel[] | null = null;

  get children(): LocalDivisionLookupModel[] | null {
    return this.localDivisions;
  }

  constructor(data: HubLookup) {
    super(data);

    if (data.localDivisions) {
      this.localDivisions = data.localDivisions.map(
        (item) => new LocalDivisionLookupModel(item),
      );
    }
  }
}
